import styled, { css } from 'styled-components'
import InputLabel from '@material-ui/core/InputLabel'
import Box from '@material-ui/core/Box'

export const Label = styled(InputLabel)`
  margin-bottom: 8px;
  min-width: 248px;
  ${({ theme }) => css`
    color: ${theme.colors.gray1} !important;
  `}
`
export const BoxCustomizado = styled(Box)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 633px;
  ${({ theme }) => css`
    background-color: ${theme.colors.lightBg};
  `}
  padding: 36px;
  border-radius: 8px;
`

export const Input = styled.div`
  margin-top: 36px;
`

export const Botoes = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 108px;
`
